import Box from '@material-ui/core/Box'
import Link from '@material-ui/core/Link/Link'
import Typography from '@material-ui/core/Typography'
import CheckIcon from '@material-ui/icons/Check'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import React, { FC, useCallback, useState } from 'react'
import { scopedTranslation } from 'src/helpers'

import { useStyles } from '../InformationCard.styles'

const { t } = scopedTranslation('component.smp.information_page.card')

export interface InformationAccordionProps {
  headline: string
  link: string
  bulletPoints: string[]
  isPreview: boolean
}

const getAccordionIcon = (isPreview: boolean, isOpen: boolean, onClick: () => void) => {
  if (isPreview) {
    return <Box color='success.main'><CheckIcon /></Box>
  }

  return isOpen ?
    <ExpandLessIcon color='primary' onClick={ onClick } /> :
    <ExpandMoreIcon color='primary' onClick={ onClick } />
}

export const InformationAccordion: FC<InformationAccordionProps> = ({
  headline, link, bulletPoints, isPreview,
}) => {
  const [ isOpen, setIsOpen ] = useState(false)
  const classes = useStyles()

  const toggleOpenState = useCallback(() => {
    setIsOpen(prevState => !prevState)
  }, [ setIsOpen ])

  return (
    <Box className={ classes.accordionItem }>
      <Box
        display='flex'
        flexWrap='no-wrap'
        className={ isPreview ? '' : classes.accordionLink }
      >
        { getAccordionIcon(isPreview, isOpen, toggleOpenState) }
        <Box fontWeight='bold' ml={ 2 }>
          <Box mr={ 1 } display='inline' onClick={ toggleOpenState }>
            { headline }
          </Box>
          <Typography variant='body2'>
            <Link underline='always' href={ link } target='_blank' rel='noopener noreferrer'>
              { t('template') }
            </Link>
          </Typography>
        </Box>
      </Box>
      { isOpen && !isPreview && bulletPoints.map(bulletPoint => (
        <Box key={ bulletPoint } position='relative' ml={ 7 } mt={ 1 }>
          <CheckIcon className={ classes.checkIcon } />
          <Typography>{ bulletPoint }</Typography>
        </Box>)) }
    </Box>
  )
}
